export const TEAM_NAME_PATTERN = /^[a-zA-Z0-9 -]+$/;
export const TEAM_NAME_MAX_LENGTH = 50;

/** Case-insensitive: the backend enforces the same protection on "Admin". */
export function isAdminTeamName(name: string): boolean {
    return name.trim().toLowerCase() === 'admin';
}

/** `null` means valid. Mirrors the backend's validator so the drawer can
 * reject before round-tripping to the API. */
export function validateTeamName(name: string): string | null {
    const trimmed = name.trim();
    if (!trimmed) return 'Team name is required';
    if (trimmed.length > TEAM_NAME_MAX_LENGTH) {
        return `Team name must be ${TEAM_NAME_MAX_LENGTH} characters or fewer`;
    }
    if (!TEAM_NAME_PATTERN.test(trimmed)) {
        return 'Only letters, numbers, spaces, and hyphens allowed';
    }
    return null;
}
